<template>
  <section>
    <podft-filter @filterHeaders="filterHeaders" @filterLoader="filterLoader"/>
    <div v-if="lists" class="rounded border bg-white info-panel custom-table">
      <loader-full v-if="loadedFilter"/>
      <div v-else class="table-responsive">
        <table class="podft table table-striped table-hover table-row-dashed fs-7 table-row-gray-300 gy-3 mb-0 text-gray-800" style="white-space: nowrap!important;">
          <thead>
            <tr class="fw-bold fs-8 text-gray-400">
              <th>ID</th>
              <th>Документ</th>
              <th class="text-center">Резидент</th>
              <th class="text-center">Физ. лицо</th>
              <th>Cущность</th>
              <th>Наименование</th>
              <th>Тип</th>
              <th>Статус</th>
              <th>Дата обращения</th>
              <th>Дата решения</th>
              <th class="text-end">Действие</th>
            </tr>
          </thead>
          <tbody v-if="lists.data.length >= 0">
            <tr v-for="(item, key) in lists.data" :key="key" @click="asideProps(item.id, key)" class="cursor-pointer align-middle">
              <td class="text-center" v-html="item.id"></td>
              <td v-html="item.document"></td>
              <td class="text-center">
                <i v-if="item.resident" class="ki-outline ki-check-circle text-primary fs-5"></i>
                <i v-else class="ki-outline ki-minus-circle text-danger fs-5"></i>
              </td>
              <td class="text-center">
                <template v-if="item.person !== null">
                  <i v-if="item.person" class="ki-outline ki-check-circle text-primary fs-5"></i>
                  <i v-else class="ki-outline ki-minus-circle text-danger fs-5"></i>
                </template>
              </td>
              <td v-html="item.entityName"></td>
              <td v-html="item.title"></td>
              <td>
                <span
                    :title="item.typeName"
                    class="badge-custom"
                    :class="'badge-custom-'+item.type"
                ></span>
              </td>
              <td> <span :class="'d-block text-center podft-status status-'+item.status" v-html="item.statusName"></span></td>
              <td>{{item.created}} | <b>{{item.created_time}}</b></td>
              <td>
                <template v-if="item.status > 1">
                  {{ item.updated }} | <b>{{item.updated_time}}</b>
                </template>
              </td>
              <td class="text-end">
                <i class="ki-outline ki-right-square text-primary fs-4"></i>
              </td>
            </tr>
          </tbody>
        </table>
        <bootstrap5-pagination class="pagination-outline pt-3 mb-3 border-top" v-if="lists" :data="lists" @pagination-change-page="getPodft"/>
        <div v-if="lists.data.length <= 0" class="p-10 text-center text-gray-600">
          Нет записи
        </div>
      </div>
    </div>
    <podft-aside-modal @close="asideClose" @updateItem="updateItem" :item-id="aside.id" :item-index="aside.index"/>
  </section>
</template>
<script>
  import axios      from 'axios'
  import LoaderFull from '@/components/Main/LoaderFull'
  import DraftCard  from '@/components/Draft/DraftCard.vue';
  import PodftAsideModal from '@/components/Podft/PodftAsideModal/PodftAsideModel';
  import PodftFilter from '@/components/Podft/PodftFilter';
  import { Bootstrap5Pagination } from 'laravel-vue-pagination';

  const filter = {
    status:         '1',
    person:         'null',
    entity:         'null',
    title:          '',
    document:       '',
    appeal_start:   '',
    appeal_end:     '',
    solution_start: '',
    solution_end:   ''
  }
  export default {
    name: 'Podft',
    components: {PodftFilter, PodftAsideModal, DraftCard, LoaderFull, Bootstrap5Pagination },
    data () {
      return {
        lists: null,
        loaded: false,
        loadedFilter: false,
        aside: {
          index: null,
          id:    null,
        },
        filter: {
          status:         '1',
          person:         'null',
          entity:         'null',
          title:          '',
          document:       '',
          appeal_start:   '',
          appeal_end:     '',
          solution_start: '',
          solution_end:   ''
        }
      }
    },
    mounted() {
      this.getPodft()
    },
    methods: {
      getPodft(page = 1) {
        const headers = {headers: {}, params: this.filter}
        axios.get('/api/podft/get?page='+page, headers)
            .then(res => {
              this.lists = Object.assign(res.data, res.data.meta)
              delete this.lists['meta']
            })
            .catch(err => {console.log(err)})
            .finally(() => {
              if (this.loadedFilter) this.loadedFilter = false
            })
      },
      asideProps(id, index) {
        this.aside.id = id
        this.aside.index = index
        new bootstrap.Modal('#podftAsideModal', {}).show()
      },
      asideClose(val) {
        if (val) {
          this.aside.id = null
          this.aside.index = null
        }
      },
      updateItem(val) {
        if (val.key !== null) {
          this.lists[val.key] = val.data
          this.aside.id    = null
          this.aside.index = null
        }
      },
      filterHeaders(val) {
        this.filter = val
        this.getPodft()
      },
      filterLoader(val) {
        this.loadedFilter = val
      }
    }
  }
</script>
<style scoped>

</style>